import React from 'react';

import { BreadcrumbsBar } from 'scenes/Trackers/components/Breadcrumbs';

export function TrackerBreadcrumbsBar({ value, onChange }) {
  const drillEntityNameFormatter = ({ drillEntityName }) =>
    drillEntityName || 'All';
  return (
    <BreadcrumbsBar
      value={value}
      onChange={onChange}
      drillEntityNameFormatter={drillEntityNameFormatter}
    />
  );
}
